import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Avatar,
  Text,
  Image,
  Stack,
  Button,
  Icon,
} from "@chakra-ui/react";
import { HiMenu } from "react-icons/hi";
import { MdImageNotSupported } from "react-icons/md";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/userActions";
import { useTranslation } from "react-i18next";
import HeaderTenantSwitch from "./HeaderTenantSwitch";
import useThemeColors from "../../hooks/useThemeColors";
import useIsMobile from "../../hooks/useIsMobile";
import {
  white,
  textSecondary,
  textPrimary,
  backgroundLight,
  primary,
  primaryAlt,
} from "../../utils/colors";
import MenuItems from "./MenuItems";
import HeaderTenantSwitchMobile from "./HeaderTenantSwitchMobile";
import MobileMenuList from "../menu/MobileMenuList";
import { FaXmark } from "react-icons/fa6";
import LanguageButtonMain from "../buttons/LanguageButtonMain";
import { TbDental } from "react-icons/tb";

const HeaderMainMobile = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = useIsMobile();

  const { whiteMode, newBorderMode } = useThemeColors();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenant = useSelector((state) => state.tenantDetailsBySlug.tenant);
  const clinicName = tenant?.clinicName || "";
  const tenantOnboardingStatus = tenant?.onboarding?.status || "";

  // MENU ITEMS

  const menuItems = MenuItems({ userInfo, tenant });

  // HANDLERS
  const handleTenantSwitch = (tenantSlug) => {
    const currentPath = location.pathname.split("/");
    currentPath[1] = tenantSlug;
    navigate(currentPath.join("/"));
    closeDrawer();
  };

  const logoutHandler = () => {
    dispatch(logout());
    closeDrawer();
  };

  const profileHandler = () => {
    navigate(`/${slug}/profile`);
    closeDrawer();
  };

  useEffect(() => {
    if (location.pathname === "/login" || location.pathname === "/register") {
      setIsDrawerOpen(false);
    }
  }, [location.pathname]);

  // console.log("userInfo in HeaderMainMobile", userInfo);

  return (
    <>
      <Box
        position="fixed"
        top="0"
        left="0"
        w="100%"
        h="80px"
        zIndex="900"
        bg={whiteMode}
        borderBottom={`1px solid ${newBorderMode}`}
      >
        <Flex h="100%" align="center" justify="space-between" px="1.5rem">
          {/* <Link to="/">
            <Image src={logo} h="1.5rem" alt="Dentacasa Logo" />
          </Link> */}
          <HeaderTenantSwitch
            slug={slug}
            tenant={tenant}
            clinicName={clinicName}
            userInfo={userInfo}
            handleTenantSwitch={handleTenantSwitch}
          />
          <IconButton
            aria-label="Open menu"
            icon={<HiMenu />}
            onClick={openDrawer}
            bg="transparent"
            fontSize="1.5rem"
            _hover={{ bg: !isMobile ? "gray.100" : "transparent" }}
          />
        </Flex>
      </Box>

      <Drawer isOpen={isDrawerOpen} placement="right" onClose={closeDrawer}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader p="0" w="100%">
            <Flex
              w="100%"
              align="center"
              justify="space-between"
              p="1.5rem"
              color={textPrimary}
            >
              <Flex align="center">
                <Avatar
                  size="sm"
                  bg="gray.500"
                  color={white}
                  name={userInfo.email}
                  mr={3}
                />
                <Stack spacing={0}>
                  <Text fontSize="sm" fontWeight="600">
                    {userInfo.name}
                  </Text>
                  <Text fontSize="xs" fontWeight="500" color={textSecondary}>
                    {userInfo.email}
                  </Text>
                </Stack>
              </Flex>
              <Flex justify="flex-end">
                <IconButton
                  aria-label="Close menu"
                  size="sm"
                  icon={<FaXmark />}
                  onClick={closeDrawer}
                  bg={backgroundLight}
                  fontSize="0.875rem"
                  _hover={{ bg: "gray.100" }}
                />
                {/* <DrawerCloseButton /> */}
              </Flex>
            </Flex>
          </DrawerHeader>

          <DrawerBody p="0">
            <Flex w="100%" align="center" justify="center" direction="column">
              {/* <Text fontSize="md" fontWeight="500" color={textSecondary}>
                Logged in as
              </Text> */}
              {/* <Flex
                align="center"
                m="1rem 0 0"
                direction="column"
                border={`1px solid ${newBorderMode}`}
                borderRadius="1rem"
              >
                <Flex
                  align="center"
                  justify="center"
                  direction="column"
                  p="2rem"
                >
                  <Avatar
                    size="md"
                    bg="gray.500"
                    color={white}
                    name={userInfo?.email}
                  />
                  <Text fontSize="1rem" fontWeight="600" m="1rem 0 0">
                    {userInfo?.name}
                  </Text>
                  <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                    {userInfo?.email}
                  </Text>
                  <Button
                    variant="outline"
                    size="md"
                    fontSize="sm"
                    m="1rem 0 0"
                  >
                    Edit profile
                  </Button>
                </Flex>
                <Box w="100%" borderTop={`1px solid ${newBorderMode}`}>
                  <Text fontSize="sm" color={textSecondary} m="0.5rem 0 0 1rem">
                    Clinic
                  </Text>
                  <Box p="0.25rem 1rem 1rem">
                    {" "}
                    <HeaderTenantSwitchMobile
                      slug={slug}
                      tenant={tenant}
                      clinicName={clinicName}
                      userInfo={userInfo}
                      handleTenantSwitch={handleTenantSwitch}
                    />
                  </Box>
                </Box>
              </Flex> */}
            </Flex>

            <Flex
              w="100%"
              m="0 0 1rem"
              borderTop={`1px solid ${newBorderMode}`}
              p="1.5rem 0 0"
            >
              <Box w="100%" p="0 1.5rem">
                <Text
                  fontSize="xs"
                  fontWeight="600"
                  color={textSecondary}
                  mb="0.25rem"
                  textTransform="uppercase"
                >
                  {t("menu.clinic")}
                </Text>
                <HeaderTenantSwitchMobile
                  slug={slug}
                  tenant={tenant}
                  clinicName={clinicName}
                  userInfo={userInfo}
                  handleTenantSwitch={handleTenantSwitch}
                  closeDrawer={closeDrawer}
                />
              </Box>
            </Flex>

            <Flex
              borderTop={`1px solid ${newBorderMode}`}
              flexGrow="1"
              p="1.5rem 0"
              // // h="calc(100% - 9rem)"
              // h="calc(100% - 5rem)"
              // p="5rem 0 0rem"
            >
              <Box w="100%" p="0 0 0 1.5rem">
                <Text
                  fontSize="xs"
                  fontWeight="600"
                  color={textSecondary}
                  mb="0.5rem"
                  textTransform="uppercase"
                >
                  {t("menu.mainMenu")}
                </Text>
                <MobileMenuList tabs={menuItems} closeDrawer={closeDrawer} />
              </Box>
            </Flex>

            <Flex
              borderTop={`1px solid ${newBorderMode}`}
              flexGrow="1"
              p="1.5rem 0 0"
              // // h="calc(100% - 9rem)"
              // h="calc(100% - 5rem)"
              // p="5rem 0 0rem"
            >
              <Box w="100%" p="0 0 0 1.5rem">
                <Text
                  fontSize="xs"
                  fontWeight="600"
                  color={textSecondary}
                  mb="0.5rem"
                  textTransform="uppercase"
                >
                  {t("menu.user")}
                </Text>
                <Stack spacing={4} mt={1} pb="1.5rem">
                  {userInfo ? (
                    <>
                      <Button
                        size="lg"
                        fontSize="sm"
                        color={textSecondary}
                        fontWeight="500"
                        variant="ghost"
                        // bg={backgroundLight}
                        onClick={profileHandler}
                        justifyContent="flex-start"
                      >
                        {t("user.myProfile")}
                      </Button>

                      {userInfo?.tenants?.length > 1 && (
                        <>
                          <Text fontSize="xs" color="gray.500" mt={2}>
                            {t("user.tenantList")}
                          </Text>

                          {userInfo.tenants.map((tenant) => (
                            <Flex
                              key={tenant.tenantID}
                              align="center"
                              p={2}
                              borderRadius="md"
                              _hover={{ bg: "gray.50", cursor: "pointer" }}
                              onClick={() => handleTenantSwitch(tenant.slug)}
                              bg={
                                tenant.tenantID === userInfo.tenantID
                                  ? "gray.100"
                                  : "transparent"
                              }
                            >
                              {tenant?.logo ? (
                                <Image
                                  src={tenant.logo}
                                  alt={clinicName}
                                  w="2.25rem"
                                  h="2.25rem"
                                  borderRadius="0.75rem"
                                  objectFit="cover"
                                  mr="0.5rem"
                                />
                              ) : (
                                <Flex
                                  align="center"
                                  justify="center"
                                  h="2.25rem"
                                  w="2.25rem"
                                  borderRadius="100%"
                                  bg={backgroundLight}
                                  // border={`1px solid ${newBorder}`}
                                  mr="0.5rem"
                                >
                                  <Icon
                                    as={TbDental}
                                    color={textSecondary}
                                    fontSize="0.875rem"
                                  />
                                </Flex>
                              )}
                              <Stack spacing={0}>
                                <Text fontSize="sm" fontWeight="500">
                                  {tenant.slug}
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                  {t(`role.${tenant.role}`)}
                                </Text>
                              </Stack>
                            </Flex>
                          ))}
                        </>
                      )}

                      <Button
                        size="lg"
                        fontSize="sm"
                        fontWeight="500"
                        variant="ghost"
                        colorScheme="red"
                        onClick={logoutHandler}
                        justifyContent="flex-start"
                      >
                        {t("common.logout")}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outline"
                        onClick={() => {
                          navigate("/login");
                          closeDrawer();
                        }}
                        colorScheme="gray"
                      >
                        {t("landing.navLogin")}
                      </Button>
                      <Button
                        colorScheme="purple"
                        bg={primary}
                        _hover={{ bg: primaryAlt }}
                        onClick={() => {
                          navigate("/register");
                          closeDrawer();
                        }}
                      >
                        {t("landing.navRegister")}
                      </Button>
                    </>
                  )}
                </Stack>
              </Box>
            </Flex>
            <Flex
              borderTop={`1px solid ${newBorderMode}`}
              flexGrow="1"
              p="1.5rem 0 6rem"
              // // h="calc(100% - 9rem)"
              // h="calc(100% - 5rem)"
              // p="5rem 0 0rem"
            >
              <Box w="100%" p="0 0 0 1.5rem">
                <Text
                  fontSize="xs"
                  fontWeight="600"
                  color={textSecondary}
                  mb="0.5rem"
                  textTransform="uppercase"
                >
                  {t("menu.language")}
                </Text>
                <Box w="100%" m="0rem 0 0" p="1rem 0rem 0rem 0.75rem">
                  <LanguageButtonMain bg={backgroundLight} />
                </Box>
              </Box>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default HeaderMainMobile;
